import {isFSA} from 'flux-standard-action'
import {constants as kandyConstants} from 'kandy-redux'
import * as types  from '../../constants/ActionTypes'
import * as lossAssConstants from '../constants/ActionTypes'
import {reportPreviewActions,report} from '../actions'
import {currentCallActions} from '../../actions'
import _ from 'lodash'
let middleware = ({dispatch, getState}) => {
    return next => action => {
        if (isFSA(action)) {
            if(action.type===lossAssConstants.CREATE_CAR_FINISH){
                dispatch(reportPreviewActions.getLatestReport(getState().lossAss.reportPreview.currentPreviewReport.flowId))
            }
            else if(action.type===lossAssConstants.UPLOAD_PICC_FINISH){
                dispatch(reportPreviewActions.getLatestReport(getState().lossAss.reportPreview.currentPreviewReport.flowId))
            }else if(action.type===lossAssConstants.BIND_AGENT_FINISH){
                dispatch(reportPreviewActions.getLatestReport(action.payload.flowId))
            }else if(action.type===types.END_SESSION){
                let fullScreen=getState().app.currentCall.showFull
                if(fullScreen=='show'){

                    dispatch(currentCallActions.showFullScreen("close"))
                    let openVideoBox =  document.getElementById("video-box-container")
                    openVideoBox&&openVideoBox.setAttribute("class",'video-modal video-modal-picc')
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    }
                    else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                    else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    }
                    else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen();
                    }
                }
            }

            if (action.type === kandyConstants.MESSAGE_RECEIVED && action.payload.message
                && action.payload.message.message.additional_data) {

                let data = action.payload.message.message.additional_data
                if (data.type === 'control' && data.subType) {
                    let subData = data.subType

                    if(subData && subData.hasOwnProperty('uploadScreenshot')){
                         let imgData = subData.uploadScreenshot

                         dispatch(reportPreviewActions.loadCustomerUploadImg(imgData))
                    }else if(subData && subData.hasOwnProperty('reporter')){
                        if(subData.reporter.channelType==='business'&&subData.reporter.state==='tbc'){
                            dispatch(reportPreviewActions.getLatestReport(getState().lossAss.reportPreview.currentPreviewReport.flowId))
                        }
                    }else if(subData && subData.hasOwnProperty('evaluation')){

                        let evaluation = subData.evaluation
                        let flowId
                        try{ flowId = getState().lossAss.reportPreview.currentPreviewReport.flowId }catch(e){}
                        dispatch(report.showEvaluation(evaluation, flowId))

                    }
                }
            }
            if(action.type == types.SEARCH_REPORT_FINISH){
                dispatch(reportPreviewActions.showMeasure(false))//去掉工作台个定损中心全选增强的图片
            }
        }
        return next(action)
    }
}

export default middleware

